import React from 'react';
import BlogPost from "../BlogPost";

const EnilsCoin = () => {
    return (
        <BlogPost
            id="EnilsCoin"
            title="Enil's Coin"
            content={
                <>
                    The massive creature moved on all fours crossing its lair, its guest watching it
                    lumber along and smiling at the transformation as the limbs, thick as a
                    thousand-year-old tree, became as slender as those of Celista the god of elves. As
                    the monstrous creature finished shifting to a more manageable size, six and a half
                    feet or so tall, they raised a claw, the black nails and scales a molten gold with
                    streaks of red, like lava running through it, glistening in the light, to cover
                    their mouth before clearing their throat and apologizing, &quot;please excuse my
                    tardiness Ballate, had a squabble between Crimson and Gleam to settle.&quot;
                    <br/><br/>
                    &quot;It’s fine. No contract broken nor harm caused, simply a polite delay and time
                    for the tea to finish steeping,&quot; with a gesture to the pot and a
                    smile &quot;shall I pour for us both?&quot;
                    <br/><br/>
                    &quot;Certainly my friend&quot; Alsern, the god of dragons replied, pulling out a
                    chair and sitting at the small wooden table. The wrapped cloth of dark golden scales
                    that hung over Alsern’s shoulders and across their chest with a pair of dark red
                    cloth pants and short boots of a similarly colored leather. All of which gave the
                    origin of dragons and possession a fanciful air to them. Still, their guest knew
                    better. Alsern was a mighty creature and likely the most powerful of the origins in
                    raw strength. Alsern took a moment to fix their top before asking &quot;your message
                    said you had a story to share? Does it have something to do with those pesky demons
                    your people are managing to hold back or something more fun?&quot;
                    <br/><br/>
                    &quot;More fun&quot; Ballate responded offhandedly taking a sip of the tea the
                    bright white and gold accented cup an intense contrast with their red-purple-toned
                    skin and white claw like nails &quot;might be a bit disappointing, actually. It’s
                    about that coin of yours.&quot;
                    <br/><br/>
                    &quot;Ah yes, the first treasure! Had Burkrr craft that for me! I’ve heard from
                    Burkrr themselves that their people have begun crafting coins as a representation of
                    wealth and to be used as currency. Those dwarves are rather handy with such things
                    after all. What could be disappointing about that?&quot;
                    <br/><br/>
                    &quot;Well, you traded it to Anniatria in exchange a fragment of their concept
                    didn’t you.&quot;
                    <br/><br/>
                    &quot;Indeed, gave the fragment of home to my children. Crimson used it to create
                    the concept of lair&quot; Alsern gestured to the space around the two
                    gods.  &quot;Crimson says lair will allow powerful mortals to manifest some control
                    over their space in the way we can so easily do. Gleam designed protection from the
                    concept of home on the other hand. Said it was about being able to keep save one’s
                    home and would be of value to all who have homes not just those powerful enough to
                    have a lair. As you can imagine, the two went for one another’s throats and I had to
                    break it up. An interesting outcome to say the least.&quot;
                    <br/><br/>
                    &quot;Yes, but do you know what happened after that?&quot; Ballate paused wating
                    Alsern raise an eyebrow and beckoned to continue &quot;well, it was traded to me for
                    a fragment of Order and Anniatria used it to create the concept of a bond for their
                    people. Those halflings are a strong clan as a result. With that your coin came to
                    rest with me.&quot;
                    <br/><br/>
                    &quot;Perfect friend! So you want to trade it back to me for something then?&quot;
                    <br/><br/>
                    &quot;No, it’s&quot; Ballate took a sip of tea, avoiding eye contact, and mumbling
                    something incomprehensible.
                    <br/><br/>
                    &quot;Come again.&quot;
                    <br/><br/>
                    &quot;Gone.&quot;
                    <br/><br/>
                    &quot;Gone?&quot;
                    <br/><br/>
                    &quot;Yes. Gone.&quot;
                    <br/><br/>
                    &quot;What do you mean, gone.&quot;
                    <br/><br/>
                    &quot;Enil had it.&quot;
                    <br/><br/>
                    &quot;Who has it now then?&quot; A hint of annoyance beginning to rise in Alsern’s
                    voice, a bit of growl slipping out. &quot;Are you saying it’s missing?&quot;
                    <br/><br/>
                    &quot;Yes and no&quot; with a smash Alsern interrupts, his fist down shattering a
                    saucer in the process, &quot;calm yourself! The coin is a bit everywhere it’s in a
                    state of everything. I don’t know how else to explain it!&quot; Ballate jumps to his
                    feet to dodge the table as Alsern flips it in anger. The following cascade of
                    breaking dishware clattering to the ground ended with the resonant thud of the table
                    landing where Ballate had been a moment earlier. &quot;Hold on! Let me explain it.
                    For Æ’s sake!&quot;
                    <br/><br/>
                    Alsern pauses at their creator’s name and eyes their companion. Ballate, the god of
                    demons, self-proclaimed protector of the realm from those outside it, horns rising
                    from his forehead, the off-white tone in contrast to the deep red-purple skin. Their
                    black loose pants tucked into knee-high boots, cuffed at the top, and black shirt
                    beneath brown leather vest. &quot;Speak. Quickly&quot; Alsern roars.
                    <br/><br/>
                    &quot;So, the coin came to me, and shortly after Enil showed up and wanted it. They
                    said they heard about it from Burkrr. Enil told me that the coins weren’t spreading
                    amongst the mortals. They seemed to ‘set,’ whatever on earth that means. As such, I
                    asked what Enil could trade. They said nothing. Nothing at all. I asked about their
                    concept. They said they still haven’t really ‘figured it out.’ Truly what are we to
                    do with little Enil.&quot;
                    <br/><br/>
                    &quot;Get to the point!&quot; Alsern pronounced, a bit of their intense presence
                    sending shivers up Ballate’s spine.
                    <br/><br/>
                    &quot;My apologies. Yes, unable to offer anything in trade, Enil came up with a
                    novel concept and proposed to leave it to fate. A simple toss of the coin itself. I
                    thought it ridiculous but agreed. Especially so being in exchange for the coin Enil
                    offered the entire race of humans to serve in my battle to protect the realm. So we
                    flipped the coin, and, as you may have realized already, it landed in Enil’s favor.
                    I lost the coin to Enil.&quot;
                    <br/><br/>
                    &quot;Then Enil has it?&quot;
                    <br/><br/>
                    &quot;No, for they looked at me and said ‘wouldn’t it be interesting if an outcome
                    could be change?’ Before I had time to consider their words, Enil flipped the coin
                    high in the air and said aloud ‘if the front falls face up the following outcome
                    will be the same.’ I watched it land front facing up and continued to stare on as
                    they flipped it again. It worked. Three flips in Enil’s favor in a row. Enil did it
                    the process again, repeating their statement. I couldn’t do anything but watch
                    enraptured with the process. Four, five, six, seven and then on the eight flip Enil
                    made the wager yet again. This time though, when the coin fell into their palm, I
                    was able to see it, the reverse side face up. This was only a very brief moment, and
                    the next the coin was gone.&quot;
                    <br/><br/>
                    Dumbfounded Alsern stood in silence eying Ballate and breaking the moment of
                    pause &quot;what then? What do you mean it’s everywhere?&quot;
                    <br/><br/>
                    &quot;Enil and I looked into it. It seems some number of coins are now the coin.
                    Each one able to change the outcome of these sorts of events of 'luck' as Enil is
                    now refering to them.&quot;
                    <br/><br/>
                    &quot;Multiple coins? We can collect them then. I’m sure Greed would love to do
                    it!&quot;
                    <br/><br/>
                    &quot;That’s the thing, they just happen. A coin that isn’t one can just become one
                    and one that is, when it fails to succeed at creating the set event. It just goes
                    away. We can’t even figure out if another coin becomes one when that happens. We
                    just know they exist, they aren’t permanent, and, seemly, are consistently
                    inconsistent.&quot;
                    <br/><br/>
                    Alsern in exhaustion sits down and puts their head in their hands &quot;Ballate what
                    on earth did the two of you do. This is madness, but, based on what you’ve said,
                    there’s nothing to be done about this.&quot;
                    <br/><br/>
                    &quot;For what it’s worth, Parasus has been working with Erlki to test a number of
                    them that Erlki’s people have collected. Parasus believes they have something called
                    a ‘quantum state’ and&quot; Ballate fumbles and, pulling a piece of paper from their
                    pocket, continues &quot;‘meaning they lack a state until observed at which point
                    they become one or the other with usages of the coin seeming to create a chance to
                    disrupt that state and cause the coin to just be a coin’ whatever that means.
                    Parasus is truly incomprehensible sometimes.&quot;
                    <br/><br/>
                    &quot;So what now Ballate?&quot;
                    <br/><br/>
                    Ballate extends a hand to their mighty friend, family member, and fellow child of
                    Æ. &quot;I say we go see for ourselves.&quot;
                    <br/><br/>
                    Alsern smiles back at Ballate’s sly smile. &quot;A walk amongst the mortals it
                    is.&quot;
                    <br/><br/>
                    The two, walking away, laughing about the mess. Each, both literal and figurative,
                    pulling a fragment of the universe into their hands. Shaping it into a cloak and
                    wrapping themselves in it before raising the hoods and stepping into the realm of
                    the mortals. As they did, though neither could hear over their own chatters, or see
                    around the edge of their cloaks, a wisp of mist blew through the cavern, and a
                    single coin fell to the ground clattering among the broken dishes. The visage of a
                    human on one face and Æ’s star on the reverse.


                </>
            }
            photoSrc=""
            photoAlt=""
            noteText="Fate is inconsiquential in the face of luck. - Reyleigh Vormund"
        />
    );
};

export default EnilsCoin;
